// This file shared with My Account and Blog

import "@/styles/interproject.scss"
import { register } from "../helpers/stimulus"

import { setupTabs } from "@/components/tabs"
import { setupNavbar } from "@/components/navbar"
import { setupFooter } from "@/components/footer"

import AccordionController from "../controllers/accordion_controller"
import InterprojectController from "../controllers/interproject_controller"

const setupStimulus = (): void => {
  register("accordion", AccordionController)
  register("interproject", InterprojectController)
}

setupStimulus()

setupTabs()
setupNavbar()
setupFooter()
